import { createStore } from "vuex";

import ProfireLine from "@/store/modules/ProfireLine";
import AuthModule from "@/store/modules/AuthModule";
import RegisterModel from "@/store/modules/RegisterModel";

const store = createStore({
  modules: {
    ProfireLine,
    AuthModule,
    RegisterModel,
  },
});

export default store;
